export default __webpack_public_path__ + "static/media/image_banner_mini.4b4031a0.png";